import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";


const API_BASE_URL = process.env.REACT_APP_BASE_URL

// Thunks for async actions
//////console.log(API_BASE_URL, "filmsSlicefilmsSlicefilmsSlicefilmsSlice");
export const fetchFilms = createAsyncThunk(
  "films/fetchfilms",
  async (data, { rejectWithValue }) => { // Accept page and limit as parameters
    try {
      let {page,limit} = data
      // Pass the page and limit as query parameters to the API request
      const response = await axios.get(`${API_BASE_URL}/films/fetch`, {
        params: {
          page,
          limit
        }
      });
      //console.log("response",   );
      return response.data; // Return the film data
    } catch (error) {
      // If an error occurs, return it with rejectWithValue
      return rejectWithValue(error.response.data);
    }
  }
);
export const fetchFilmById = createAsyncThunk(
  'photography/fetchPhotographyById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/films/fetch/${id}`);
      //console.log('response',response)
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchFilmsByCategory = createAsyncThunk(
  "films/fetchFilmsByCategory",
  async (data, { rejectWithValue }) => {
    let {category, page, limit} = data
    try {
      const response = await axios.get(`${API_BASE_URL}/films/fetch/category/${category}`, {
        params: {
   
          page,
          limit,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);
